<app-page-header
  [pageTitle]="'Clientes'"
  [showCreateButton]="permissionAuth.canCreate('clientes')"
  [textButton]="'Nuevo cliente'"
  (onCreateClick)="create()"
/>

<!-- Filtros -->
<app-filters-container
  [hasData]="clientes.length > 0"
  [hasActiveFilters]="hasActiveFilters"
  [loading]="loading"
  (clearFilters)="clearFilters()"
>
  <app-search-input
    label="Buscar"
    [value]="filtros.busqueda"
    placeholder="Nombre, apellido, documento, razón social..."
    containerClass="flex-1 min-w-80"
    (searchChange)="onSearchChange($event)"
  />

  <app-filter-select
    label="Tipo"
    selectId="filtro-tipo-persona"
    [value]="filtros.tipo"
    [options]="tipoOptions"
    (valueChange)="onTipoChange($event)"
  />

  <app-filter-select
    label="Contrato"
    selectId="filtro-estado-contrato"
    containerClass="min-w-[170px]"
    [value]="filtros.estado_contrato"
    [options]="estadoContratoOptions"
    (valueChange)="onEstadoContratoChange($event)"
  />
</app-filters-container>

<!-- Tabla -->
<app-data-table
  [columns]="columns"
  [data]="clientes"
  [loading]="loading"
  (rowClick)="onRowClick($event)"
>
  <!-- Persona -->
  <ng-template appTableCell="persona" let-cliente>
    <!-- Los clientes nuevos guardan el nombre completo en `nombre` y no tienen apellido -->
    {{ cliente.persona.persona_tipo_detalle.nombre }}{{ cliente.persona.persona_tipo_detalle.apellido ? ' ' + cliente.persona.persona_tipo_detalle.apellido : '' }}
  </ng-template>

  <!-- Documento -->
  <ng-template appTableCell="documento" let-cliente>
    {{ cliente.persona.documento_principal.documento_completo }}
  </ng-template>

  <!-- Tipo persona -->
  <ng-template appTableCell="tipo_persona" let-cliente>
    @if (cliente.persona.persona_tipo === 'J') {
      <app-badge [startIcon]="'apartment'">Persona jurídica</app-badge>
    } @else {
      <app-badge [startIcon]="'person'" [color]="'light'">Persona física</app-badge>
    }
  </ng-template>

  <!-- Tipo cliente -->
  <ng-template appTableCell="tipo_cliente" let-cliente>
    @if (cliente.tipo_cliente) {
      <app-badge
        [startIcon]="'label'"
        [color]="cliente.tipo_cliente.activo ? 'primary' : 'light'"
      >
        {{ cliente.tipo_cliente.nombre }}
      </app-badge>
    } @else {
      <span class="text-gray-500 dark:text-gray-400">Sin tipo</span>
    }
  </ng-template>

  <!-- Razón social -->
  <ng-template appTableCell="razon_social" let-cliente>
    <div class="flex flex-col">
      @if (cliente.persona.dato_facturacion) {
        {{ cliente.persona.dato_facturacion.razon_social }}
      } @else {
        Sin datos de facturación
      }
    </div>
  </ng-template>

  <!-- Estado de contrato -->
  <ng-template appTableCell="contrato" let-cliente>
    @if (cliente.estado_contrato) {
      @let badge = badgeContrato(cliente.estado_contrato);
      <app-badge [startIcon]="badge.icon" [color]="badge.color">{{ badge.label }}</app-badge>
    }
  </ng-template>

  <!-- Fecha de conversión -->
  <ng-template appTableCell="fecha_conversion" let-cliente>
    @if (cliente.conversiones && cliente.conversiones.length > 0) {
      @for (conversion of cliente.conversiones; track conversion.id + '-' + index; let index = $index) {
        {{ conversion.fecha_conversion | date:'dd/MM/yyyy' }}
      }
    } @else {
      <span [matTooltip]="'El cliente no se creó a partir de un prospecto'">
        N/A
      </span>
    }
  </ng-template>
</app-data-table>

<!-- Paginación -->
<app-pagination
  [currentPage]="currentPage"
  [lastPage]="lastPage"
  [perPage]="perPage"
  [total]="total"
  (pageChange)="onPageChange($event)"
  (perPageChange)="onPerPageChange($event)"
/>
